import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51fdaaf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "partners-table__table"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Партнерская программа удалена", -1))

import { computed, onMounted, ref, Ref } from 'vue';
import { ItemType } from '@/types/TableTypes';
import { usePartnerProgramStore } from '@/store/modules/partnerProgram';
import { PartnerProgramType } from '@/types';

type PaginationDataType = {
  page: number;
  pageSize: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerProgramTable',
  emits: ['editPartnerProgram'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const showDeleteDataModal = ref(false);
const key = ref(0);
const downloadFiles = async (item: ItemType) => {
  await usePartnerProgramStore().downloadDocuments(+item['id'].value);
};
const editPartnerProgram = (item: ItemType) => {
  emit('editPartnerProgram', item);
};
const deletePartnerProgram = async (item: ItemType) => {
  isLoading.value = true;
  try {
    const res = await usePartnerProgramStore().deletePartnerProgram(+item['id'].value);

    if (res) {
      showDeleteDataModal.value = true;
      key.value++;
      await getPrograms();
    }
  } finally {
    isLoading.value = false;
  }
};
const headers = [
  {
    text: 'Дата создания',
    value: 'createDate',
    align: 'left',
  },
  {
    text: 'Период действия',
    value: 'period',
    align: 'left',
  },
  {
    text: 'Объявления',
    value: 'ads',
    align: 'left',
  },
  {
    text: '%',
    value: 'percent',
    align: 'left',
  },
  {
    text: 'Файлы',
    value: 'files',
    align: 'left',
    click: downloadFiles,
  },
  {
    text: '',
    value: 'edit',
    align: 'center',
    click: editPartnerProgram,
  },
  {
    text: '',
    value: 'delete',
    align: 'center',
    click: deletePartnerProgram,
  },
];

const values = computed(() => {
  let values = usePartnerProgramStore().partnerPrograms;

  if (values.length > paginationData.value.pageSize) {
    values = values.slice(0, paginationData.value.pageSize);
  }

  return values;
});

const prepareValues = computed((): PartnerProgramType[] => {
  return values.value;
});
const isLoading = ref(false);
const paginationData: Ref<PaginationDataType> = ref({
  page: 1,
  pageSize: 5,
});
const objectCount: Ref<number | undefined> = ref(undefined);

const getPrograms = async () => {
  isLoading.value = true;
  try {
    const res = await usePartnerProgramStore().getAllPartnerPrograms(
      paginationData.value,
    );

    if (res) {
      objectCount.value = res.count;
    }
  } finally {
    isLoading.value = false;
  }
};

const changePageAndPageSize = async (data: { page: number; pageSize: number }) => {
  if (
    data.pageSize !== paginationData.value.pageSize ||
    data.page !== paginationData.value.page
  ) {
    paginationData.value = {
      page: data.page,
      pageSize: data.pageSize,
    };
  }
  await getPrograms();
};

onMounted(async () => {
  await getPrograms();
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_table = _resolveComponent("base-table")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(_component_base_card, {
          key: 0,
          class: "partners-table container center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_spinner, {
              size: 50,
              color: "#009D3E"
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_base_card, {
          key: 1,
          class: "partners-table",
          "full-width-mobile": ""
        }, {
          default: _withCtx(() => [
            (values.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_base_table, {
                    headers: headers,
                    items: prepareValues.value,
                    style: 'simple'
                  }, {
                    ads: _withCtx((adsProps) => [
                      (Array.isArray(adsProps.data.value))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adsProps.data.value, (ad, i) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: ad.id
                              }, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'offerCard', params: { url: ad.url } }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(ad.id), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                (i !== adsProps.data.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, ", "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, "Партнерские программы не найдены")),
            (values.value.length)
              ? (_openBlock(), _createBlock(_component_base_pagination_group, {
                  key: 2,
                  customPage: paginationData.value.page,
                  itemCountOnPage: paginationData.value.pageSize,
                  "max-for-visible": 20,
                  objectCount: objectCount.value,
                  "show-btn": false,
                  "step-for-visible": 5,
                  value: prepareValues.value,
                  values: values.value,
                  class: "mt--20",
                  onChangePageAndPageSize: changePageAndPageSize
                }, null, 8, ["customPage", "itemCountOnPage", "objectCount", "value", "values"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
    (_openBlock(), _createBlock(_component_base_info_modal, {
      key: key.value,
      "show-info-modal": showDeleteDataModal.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (showDeleteDataModal.value = false))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["show-info-modal"]))
  ]))
}
}

})